<div class="flex h-screen bg-gray-100">
  <!-- Lista chat laterale -->
  <div class="w-80 bg-white border-r border-gray-200 flex flex-col">
    <div class="p-4 border-b border-gray-200 flex flex-col gap-3">
      <h2 class="text-xl font-semibold">Messaggi</h2>
      <div class="flex flex-col gap-2">
        <textarea
          [ngModel]="adminMessageText()"
          (ngModelChange)="adminMessageText.set($event)"
          [disabled]="isContactingAdmin()"
          rows="2"
          placeholder="Scrivi un messaggio al supporto..."
          class="w-full text-sm border border-gray-300 rounded-lg px-3 py-2 resize-none focus:outline-none focus:ring-2 focus:ring-black disabled:opacity-50"></textarea>
        <button
          (click)="contactAdmin()"
          [disabled]="isContactingAdmin() || !adminMessageText().trim()"
          class="flex items-center justify-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm">
          @if (isContactingAdmin()) {
            <span class="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></span>
            <span>Invio...</span>
          } @else {
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"/>
            </svg>
            <span>Contatta il supporto</span>
          }
        </button>
      </div>
    </div>
    
    <div class="flex-1 overflow-y-auto">
      @if (isLoading() && chats().length === 0) {
      <div class="flex justify-center items-center h-full">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
      } @else if (chats().length === 0) {
      <div class="flex flex-col justify-center items-center h-full gap-3 text-gray-400 p-4 text-center">
        <p>Nessuna chat disponibile</p>
        <p class="text-xs">Clicca su "Contatta il supporto" per iniziare</p>
      </div>
      } @else {
        @for (chat of chats(); track chat.id) {
        <div 
          (click)="selectChat(chat)"
          class="p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors"
          [class.bg-gray-100]="selectedChat()?.id === chat.id">
          <div class="font-semibold text-sm">{{ getChatName(chat) }}</div>
          <div class="text-xs text-gray-500 mt-1">
            {{ chat.updatedAt | date:'short' }}
          </div>
        </div>
        }
      }
    </div>
  </div>

  <!-- Area chat -->
  <div class="flex-1">
    @if (selectedChat()) {
    <wun-chatbot 
      [chatId]="selectedChat()!.id" 
      [userId]="currentUserId()" 
      [targetUserId]="selectedChat()!.fromUser.id === currentUserId() ? selectedChat()!.toUser.id : selectedChat()!.fromUser.id">
    </wun-chatbot>
    } @else {
    <div class="flex flex-col justify-center items-center h-full text-gray-400 gap-2">
      <svg class="w-12 h-12 opacity-30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M8 12H8.01M12 12H12.01M16 12H16.01M21 12C21 16.4183 16.9706 20 12 20C10.4607 20 9.01172 19.6565 7.74467 19.0511L3 20L4.39499 16.28C3.51156 15.0423 3 13.5743 3 12C3 7.58172 7.02944 4 12 4C16.9706 4 21 7.58172 21 12Z"/>
      </svg>
      <p>Seleziona una chat per iniziare</p>
    </div>
    }
  </div>
</div>
